/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeeAbsenceSummary } from './EmployeeAbsenceSummary';
import {
    EmployeeAbsenceSummaryFromJSON,
    EmployeeAbsenceSummaryFromJSONTyped,
    EmployeeAbsenceSummaryToJSON,
    EmployeeAbsenceSummaryToJSONTyped,
} from './EmployeeAbsenceSummary';

/**
 * 
 * @export
 * @interface ListEmployeeAbsenceSummariesResponse
 */
export interface ListEmployeeAbsenceSummariesResponse {
    /**
     * 
     * @type {Array<EmployeeAbsenceSummary>}
     * @memberof ListEmployeeAbsenceSummariesResponse
     */
    data: Array<EmployeeAbsenceSummary>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeeAbsenceSummariesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeeAbsenceSummariesResponse interface.
 */
export function instanceOfListEmployeeAbsenceSummariesResponse(value: object): value is ListEmployeeAbsenceSummariesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeeAbsenceSummariesResponseFromJSON(json: any): ListEmployeeAbsenceSummariesResponse {
    return ListEmployeeAbsenceSummariesResponseFromJSONTyped(json, false);
}

export function ListEmployeeAbsenceSummariesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeeAbsenceSummariesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeAbsenceSummaryFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeeAbsenceSummariesResponseToJSON(json: any): ListEmployeeAbsenceSummariesResponse {
      return ListEmployeeAbsenceSummariesResponseToJSONTyped(json, false);
  }

  export function ListEmployeeAbsenceSummariesResponseToJSONTyped(value?: ListEmployeeAbsenceSummariesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeAbsenceSummaryToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

